import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
    root: {
        width: '100%',
        //marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        //minWidth: 700,
    },
});

let id = 0;
function createData(alertId, routine, status) {
    id += 1;
    return { id, alertId, routine, status};
}

const rows = [
    createData(18283 , 'ConflictOfInterest', 'Overdue'),
    createData(18243 , 'DuplicatePO', 'Overdue'),
    createData(19183 , 'MissingAmount', 'Overdue'),
    createData(17043 , 'DuplicatePO', 'High Risk'),
    createData(18001 , 'DuplicateInv', 'High Risk'),
];

class PriorityAlert extends Component{


    render() {
        const classes = this.props;
        return (
            <div className={classes.root}>
                <Table className={classes.table} style={{overflowY: 'auto'}}>
                    <TableHead>
                        <TableRow>
                            <TableCell>AlertID</TableCell>
                            <TableCell >Routine</TableCell>
                            <TableCell >Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map(row => {
                            return (
                                <TableRow key={row.id}>
                                    <TableCell component="th" scope="row">
                                        {row.alertId}
                                    </TableCell>
                                    <TableCell >{row.routine}</TableCell>
                                    <TableCell >{row.status}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </div>
        )
    }
}

PriorityAlert.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PriorityAlert);


// WEBPACK FOOTER //
// ./src/components/Dashboard/PriorityAlertTable.js